export enum SmsStatus {
  Delivered = "delivered",
  Failed = "failed",
  FailedRetry = "failed-retry",
  New = "new",
  Queued = "queued",
  Received = "received",
  Sending = "sending",
  Sent = "sent",
  Undelivered = "undelivered",
  Unknown = "unknown",
  ValidationFailed = "validation-failed",
}

const FAILED_SMS_STATUSES: SmsStatus[] = [
  SmsStatus.Failed,
  SmsStatus.FailedRetry,
  SmsStatus.ValidationFailed,
];

export const isSmsStatusFailed = (status: SmsStatus) =>
  FAILED_SMS_STATUSES.includes(status);
